import { Logger } from '../services/logger.service';

const logger = new Logger('url');

export function getBaseUrl(url: string, defaultValue: string = ''): string {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.origin;
    } catch (error) {
      return defaultValue;
    }
  }

  export function addQueryParam(url: string, key: string, value?: string | null): string {
    try {
      const urlObj = new URL(url, window.location.origin);
      if (value == null) {
        // Manually rebuild query string to preserve existing keys
        const params = urlObj.search
          .slice(1)
          .split('&')
          .filter(p => p && !p.startsWith(`${key}=`) && p !== key);
  
        params.push(key);
        urlObj.search = '?' + params.join('&');
      } else {
        urlObj.searchParams.set(key, value);
      }
      return urlObj.toString();
    } catch (err) {
      logger.error('Invalid URL:', url);
      return url;
    }
  }